/**
 * Scroll reveal: thin entry that instantiates RevealText with default selectors.
 * Selectors can be overridden by callers; inject from outside when needed.
 */
import { RevealText, type RevealTextSelectors } from './RevealText';

let revealInstance: RevealText | null = null;

/**
 * Initialize scroll reveal (reveal-down DOM wrap, reveal-char, reveal-wrap GSAP).
 * Call with custom selectors to override defaults.
 */
export function initReveal(selectors?: RevealTextSelectors): RevealText {
  if (revealInstance) {
    revealInstance.destroy();
  }
  revealInstance = new RevealText(selectors);
  revealInstance.init();
  return revealInstance;
}

export { RevealText, type RevealTextSelectors } from './RevealText';
